//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    baseSku: {
      type: String,
      required: true
    }
  }
}
